import { SalesOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1630. 受注案件契約タスク登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  contract_context_id: number;
  name: string;
  description?: string;
  due_date?: string;
};
const createSalesOrderContractTask = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks`,
    props
  );
};
export const useCreateSalesOrderContractTask = () => {
  return useMutation({
    mutationFn: createSalesOrderContractTask
  });
};